// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { HTMLColors } from '@Constants/colors';
import { classList } from '@Helpers/className';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';

import './IconBoolean.scss';

interface IconBooleanProps {
    value: boolean;
    onClick?: () => void;

    readOnly?: boolean;
    label?: string;

    className?: string;

    icon?: ReactElement;
    onTrue?: {
        icon?: ReactElement;
        color?: HTMLColors;
    };
    onFalse?: {
        icon?: ReactElement;
        color?: HTMLColors;
    };
}

export const IconBoolean = ({
    value,
    onClick,
    readOnly = false,
    icon,
    onTrue,
    onFalse,
    label,
    className = '',
}: IconBooleanProps): ReactElement => {
    const iconParsed = (value && onTrue?.icon) || (!value && onFalse?.icon) || icon;

    const color = value ? onTrue?.color || HTMLColors.BLUE : onFalse?.color || HTMLColors.GRAY;

    return (
        <THTooltip title={label}>
            <span
                onClick={(): void => {
                    if (!readOnly) {
                        onClick?.();
                    }
                }}
                className={classList('icon-boolean', className, { 'cursor-pointer': !!onClick })}
            >
                {iconParsed &&
                    React.cloneElement(iconParsed, {
                        style: { color, '--fa-primary-color': color, '--fa-secondary-color': color },
                    })}
            </span>
        </THTooltip>
    );
};
